@if (!pageConfigService.isSafari()) {
  <picture class="tutoring-info__image__media">
    <img [src]="img.src" [alt]="img.alt" style="width: auto" />
  </picture>
}

@if (pageConfigService.isSafari()) {
  <img
    [src]="img.src"
    [alt]="img.alt"
    class="tutoring-info__image__media"
    sources="getsources()"
    sizes="getSizes()"
    style="width: auto"
  />
}
